// Toggle this to switch between CDN and direct Supabase
const USE_CDN = true;

const SUPABASE_STORAGE = 'https://dmnsynbxftuqmubdnhgw.supabase.co/storage/v1/object/public/';
const CDN_URL = 'https://onthemoovimages.ahmeds-rsa.workers.dev/';

export const getImageUrl = (url) => {
  if (!url || !USE_CDN) return url;
  
  if (url.includes(SUPABASE_STORAGE)) {
    return url.replace(SUPABASE_STORAGE, CDN_URL);
  }
  return url;
};